import { configs } from './configs';
import { fts } from './fts';

export const v1 = {
  configs,
  fts,
};
